import '@fontsource-variable/inter'
import { createApp } from 'vue'
import App from './App.vue'
import { installListBeneath } from './lib/back'
import { startServiceWorker } from './lib/offline'
import { installScrollMemory } from './lib/scroll-memory'
import './styles.css'
import { router } from './router'

// Before mount, so the worker's first "saved copy" message has a listener.
startServiceWorker()
installScrollMemory(router)
installListBeneath(router)
createApp(App).use(router).mount('#app')
